import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import Button from "@material-ui/core/Button";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchPaginationCartRequest,
  fetchPatchToggleStatusPaymentCart,
} from "redux/ActionCreators/CartActionCreators";
import IconButton from "@material-ui/core/IconButton";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import Box from "@material-ui/core/Box";
import Collapse from "@material-ui/core/Collapse";
import Typography from "@material-ui/core/Typography";
import { PAYMENT_METHOD } from "shared/Constants";
import Switch from "@material-ui/core/Switch";
import toArrayImageFromImageRegex from "shared/func/toArrayImageFromImageRegex";

const useRowStyles = makeStyles({
  root: {
    "& > *": {
      borderBottom: "unset",
    },
  },
});

const columns = [
  { id: "btn", label: "" },

  { id: "name", label: "Phương thức mua", minWidth: 170 },
  { id: "code", label: "Ngày mua", minWidth: 100 },
  {
    id: "population",
    label: "Đã Thanh Toán",
    minWidth: 170,
    align: "center",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "size",
    label: "Phí ship",
    minWidth: 170,
    align: "center",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "density",
    label: "Action",
    minWidth: 170,
    align: "center",
    format: (value) => value.toFixed(2),
  },
];

function Row(props) {
  const { row, changeStatusPayment } = props;
  const [open, setOpen] = React.useState(false);
  const [statusSwitch, setStatusSwitch] = useState(
    row.dayCompleteCart ? true : false
  );
  const classes = useRowStyles();

  const handleChangeStatusPayment = () => {
    setStatusSwitch(!statusSwitch);
    changeStatusPayment(row.id);
  };

  return (
    <React.Fragment>
      <TableRow className={classes.root}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {row.paymentMethod.name}
        </TableCell>
        <TableCell align="right">{row.dayStartCart}</TableCell>
        <TableCell align="right">
          <Switch
            checked={statusSwitch}
            onChange={handleChangeStatusPayment}
            name="checkedA"
            inputProps={{ "aria-label": "secondary checkbox" }}
          />
        </TableCell>
        <TableCell align="right">{row.feeShip}</TableCell>
        <TableCell align="right">
          <Button size="large">Xóa</Button>
        </TableCell>
      </TableRow>

      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <Typography variant="h6" gutterBottom component="div">
                Thông Tin Sản Phẩm
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell>Tên</TableCell>
                    <TableCell align="right">Số Lượng</TableCell>
                    <TableCell>Ảnh</TableCell>
                    <TableCell align="right">Giá</TableCell>
                    <TableCell align="right">Giá Đã Giảm</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {row.cartDetails.map((cartRow) => (
                    <TableRow key={cartRow.id}>
                      <TableCell component="th" scope="row">
                        {cartRow.product.name}
                      </TableCell>
                      <TableCell>{cartRow.count}</TableCell>
                      <TableCell align="right" style={{ width: "10%" }}>
                        <img
                          src={
                            toArrayImageFromImageRegex(
                              cartRow.product.imageRegex
                            )[0]
                          }
                          alt="Not Found"
                        />
                      </TableCell>
                      <TableCell align="right">
                        {cartRow.product.price}
                      </TableCell>
                      <TableCell align="right">
                        {cartRow.product.priceDiscount}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>

      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <Typography variant="h6" gutterBottom component="div">
                Thông Tin Khách Hàng
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell>Tên</TableCell>
                    <TableCell>Địa Chỉ</TableCell>
                    <TableCell align="right">Địa Chỉ Chi Tiết</TableCell>
                    <TableCell align="right">Số DT</TableCell>
                    <TableCell align="right">Email</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell component="th" scope="row">
                      {row.userInformation.firstName}{" "}
                      {row.userInformation.lastName}
                    </TableCell>
                    <TableCell>
                      {row.userInformation.commune}-
                      {row.userInformation.district}-
                      {row.userInformation.provincial}
                    </TableCell>
                    <TableCell align="right">
                      {row.userInformation.detailAddress}
                    </TableCell>
                    <TableCell align="right">
                      {row.userInformation.phoneNumber}
                    </TableCell>
                    <TableCell align="right">
                      {row.userInformation.email}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

const useStyles = makeStyles({
  root: {
    width: "100%",
  },
  container: {
    maxHeight: 500,
  },
});

function CartTable(props) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const classes = useStyles();
  const dispatch = useDispatch();

  const carts = useSelector((state) => state.carts.list);

  useEffect(() => {
    dispatch(fetchPaginationCartRequest(0, rowsPerPage, ""));
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    dispatch(fetchPaginationCartRequest(newPage, rowsPerPage, ""));
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
    dispatch(fetchPaginationCartRequest(0, event.target.value, ""));
  };

  const handleChangeStatusPayment = (id) => {
    dispatch(fetchPatchToggleStatusPaymentCart(id));
  };
  return (
    <Paper>
      <TableContainer className={classes.container}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {carts.data &&
              carts.data.map((row) => {
                return (
                  <Row
                    key={row.id}
                    row={row}
                    changeStatusPayment={handleChangeStatusPayment}
                  />
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={carts.total ? carts.total : 0}
        rowsPerPage={rowsPerPage}
        page={page}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </Paper>
  );
}

CartTable.propTypes = {};

export default CartTable;
